import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes.jsx'
import './index.css'

// ViteReactSSG sets up the Router and HelmetProvider for us (it depends on
// react-helmet-async internally), so existing <Helmet>/<SEO> usage keeps
// working and its tags are serialized into the static HTML at build time.
export const createRoot = ViteReactSSG(
  { routes },
  ({ isClient }) => {
    // place for client-only bootstrapping if needed later
  }
)
